<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" search :data="owners">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openFormModal"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Добавить новое</span>
          </div>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">ID</vs-th>
        <vs-th sort-key="name">Название</vs-th>
        <vs-th sort-key="category">Email</vs-th>
        <vs-th sort-key="category">Telefon</vs-th>
        <vs-th sort-key="price">Role</vs-th>
        <vs-th sort-key="order_status">Статус</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.id }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name ? tr.name : '-' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.email ? tr.email: '-' }}</p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.phone ?  tr.phone : '-' }}</p>
            </vs-td>
            <vs-td>
              <p>{{ tr.role }}</p>
            </vs-td>
            <vs-td>
              <vs-chip
                :color="getOrderStatusColor(tr.status)"
                class="product-order-status"
                >{{ getStatusName(tr.status) }}</vs-chip
              >
            </vs-td>
<!--            <vs-td class="whitespace-no-wrap">
              <a href="javascript:void(0)" @click="edit(tr)">
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                />
              </a>
            </vs-td>-->
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup title="Yo'nalish kiritish" :active.sync="formModal">

      <div class="vx-row">
        <div class="vx-col md:w-1/1 sm:-1/1 w-full flex items-center justify-center">
          <vx-card>
            <br>
            <label>FIO</label>
            <vs-input type="text" v-model="form.name" class="w-full" />
            <br/>
            <label>Telefon raqami</label>
            <vs-input type="text" v-model="form.phone" class="w-full" />
            <br/>
            <label>Emaili (mail.ru qabul qilinmaydi)</label>
            <vs-input type="email" v-model="form.email" class="w-full" />
            <br/>
            <div style="gap: 10px; display: flex">
              <vs-button class="mt-2" color="warning" @click="formModal = false">Bekor qilish</vs-button>
              <vs-button class="mt-2 mr-2" color="success" @click="submitForm">{{ 'Yaratish' }}</vs-button>
            </div>
          </vx-card>
        </div>

      </div>
    </vs-popup>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data () {
    return {
      generatedPassword: '',
      formModal: false,
      owners: [],
      form: {
        name: '',
        email: '',
        phone: '',
        password: '',
        confirm_password: '',
      },
    }
  },
  methods: {
    generatePassword() {
      const chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const passwordLength = 12;
      let password = "";
      for (let i = 0; i <= passwordLength; i++) {
        const randomNumber = Math.floor(Math.random() * chars.length);
        password += chars.substring(randomNumber, randomNumber +1);
      }
      this.generatedPassword = password
      this.form.password = password
      this.form.confirm_password = password
    },
    openFormModal() {
      this.form.name = ''
      this.form.email = ''
      this.form.phone = ''
      this.form.password = ''
      this.form.confirm_password = ''
      this.formModal = true
    },
    async submitForm() {
      this.generatePassword()
      if (this.form.password !== this.form.confirm_password) {
        this.$vs.notify({
          color: 'warning',
          title: 'Parolingizni qayta kiriting. Tasdiqlash paroli mos emas. 8 ta simvoldan kam bo\'lmasin',
          text: ''
        })
        return
      }
      await axios
        .post(`https://api.conferences-list.uz/api/v1/admin/owner/create`, this.form, {
          headers: {
            Authorization: `Bearer ${  window.localStorage.getItem('accessToken')}`
          }
        })
        .then(() => {
          this.loadOwners()
          this.formModal = false
          this.$vs.notify({
            color: 'success',
            title: 'Yangi owner qo\'shildi',
            text: ''
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'warning',
            title: 'Xatolik yuz berdi. Ma\'lumotlaringizni tekshirib qayta urubib ko\'ring',
            text: ''
          })
        })
    },
    async loadOwners () {
      await axios
        .get(`https://api.conferences-list.uz/api/v1/admin/owners`, {
          headers: {
            Authorization: `Bearer ${  window.localStorage.getItem('accessToken')}`
          }
        })
        .then(response => {
          const { data } = response
          this.owners = data.data
        })
    },
    getStatusName (value) {
      if (value === 'ACTIVE') return 'активный'
      if (value === 'EXPIRE') return 'истекший'
      if (value === 'PENDING') return 'в ожидании'
    },
    getOrderStatusColor (status) {
      if (status === 'DISABLED') return 'warning'
      if (status === 'ACTIVE') return 'success'
      if (status === 'PENDING') return 'info'
      return 'primary'
    },
  },
  async created () {
    await this.loadOwners()
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
